var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_vm._m(0),_c('ArticleForm',{attrs:{"mode":'edit'},on:{"save":_vm.UpdateArticle,"delete":_vm.DeleteArticle},model:{value:(_vm.article),callback:function ($$v) {_vm.article=$$v},expression:"article"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('h2',[_vm._v("Editar o artigo")])])
}]

export { render, staticRenderFns }